// src/utils/helpers.js

export function formatDate(dateString) {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'long' }); // e.g., "July"
  const year = date.getFullYear();

  // Helper for ordinal suffix (st, nd, rd, th)
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${getOrdinal(day)} ${month} ${year}`; // e.g., "18th July 2025"
}

// A series' endDate (e.g. "2026-08-21") is a bare date string, which
// `new Date(...)` parses as UTC midnight at the *start* of that day. Naively
// comparing that against `new Date()` makes a series register as "expired"
// the instant the clock passes midnight UTC on its own end date - i.e. for
// the entire last day it's supposed to still be active. Push the end
// boundary to the end of that calendar day before comparing, so the series
// stays active through its whole final day.
// `now` defaulting to `new Date()` only protects against an omitted
// argument, not one that's merely not a Date - and Array.filter/map call
// their callback with (element, index, array), so a bare
// `list.filter(isSeriesActive)` silently passes the numeric index as `now`
// instead of leaving it to default. Guard explicitly rather than relying on
// every call site to remember to wrap this in an arrow function.
function asDate(value) {
  return value instanceof Date ? value : new Date();
}

export function isSeriesActive(series, now) {
  if (!series || !series.startDate || !series.endDate) return false;
  now = asDate(now);
  const start = new Date(series.startDate);
  const end = new Date(series.endDate);
  end.setUTCHours(23, 59, 59, 999);
  return start <= now && now <= end;
}

export function isSeriesExpired(series, now) {
  if (!series || !series.endDate) return false;
  now = asDate(now);
  const end = new Date(series.endDate);
  end.setUTCHours(23, 59, 59, 999);
  return end < now;
}
